export default "/images/SERMO.jpg?575fb06fed54bcaaac098a1d10b42e24";